<template>
    <v-dialog-old ref="dialog" id="errorDialog">
        <div class="error-content">
            <h2><i class="fa fa-warning text-red" style="margin-right: 11px"></i>{{ error.message }}</h2>
            <template v-if="typeof error.errors !== 'string'">
                <template v-if="error.type !== 'notfound'" v-for="(errorRow,key) in error.errors">
                    <template v-if="Array.isArray(errorRow)">
                        <b>{{ key }}</b>:
                        <p v-for="errorText in errorRow" style="padding-left: 25px;">
                            <span v-html="errorText" />
                        </p>
                    </template>
                    <p v-else v-html="errorRow"></p>
                </template>
            </template>
            <p v-else v-html="error.errors"></p>
            <template v-if="showReloadBtn">
                <br />
                <div  align="center" style="width: 100%">
                    <button class="greenHover" @click.prevent="reloadPage">
                        Обновить страницу
                    </button>
                </div>
            </template>
        </div>
    </v-dialog-old>
</template>

<script>
import Vue from 'vue';

export default {
    name: "ErrorDenied",
    data: function () {
        return {
            showReloadBtn: false,
            error: {}
        };
    },
    methods: {
        reloadPage(e){
            this.$nextTick(() => {
                window.location.reload()
            });

        },
        show(error, params = {}) {
            if (params.reloadBtn !== undefined) {
                this.showReloadBtn = true;
            }else{
                this.showReloadBtn = false;
            }
            Vue.set(this, 'error', error);
            this.$refs.dialog.show();
        }
    }
}
</script>

<style lang="scss">
#errorDialog {
    max-width: 50%;
}
</style>
